import axios from 'axios';

export default {
  state: {
    filters: [],
    section_id: false,
    loading: false,
    error: null,
    filtersLoaded: false,
    noMoreFilters: false
  },
  mutations: {
    SET_FILTERS(state, filters) {
      state.filters = filters.data;
      state.filtersLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_FILTERS_LOADING(state, status) {
      state.filtersLoading = status;
    },
    SET_FILTERS_ERROR(state, error) {
      state.filtersError = error;
    }
  },
  actions: {
    async fetchFilters({ commit, state, rootState }, {id, page, sort, filter={}, search='', first=false}) {
      // Проверяем, были ли категории уже загружены
      if (id == undefined)
        return;

      if (state.filters && Object.values(state.filters).length > 0 && state.section_id == id && first) {
        //return;
      }

      state.section_id = id;

      try {
        commit('SET_FILTERS_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/filter/'+id+'/', {
          params: {q: search, filter: filter, gender: rootState.gender.gender}
        });
        commit('SET_FILTERS', response.data);
        commit('SET_FILTERS_ERROR', null);
      } catch (error) {
        commit('SET_FILTERS_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching filters:', error);
      } finally {
        commit('SET_FILTERS_LOADING', false);
      }
    }
  },
  getters: {
    filters: state => state.filters,
    filtersLoading: state => state.filtersLoading,
    filtersError: state => state.filtersError,
    filtersLoaded: state => state.filtersLoaded
  }
}